<template>
	<!--div>
		selectMcWrapper
		<div style="background:var(--grey-2);padding:10px;" class="flexcenter" title="Välj mc-märke och mc-modell">


			<select v-if="this.baseMcTree" v-model="this.brand">
				<option :value="null">Välj märke</option>
				<option v-for="(brand) in baseMcTree" :key="brand.id" :value="brand">{{ brand.name }}</option>
			</select>

			<select v-if="this.baseMcTree" v-model="this.mc">
				<option :value="null">Välj mc</option>
				<option v-for="mc in this.brand && this.brand.modelList" :key="mc.mcId" :value="mc">{{ mc.modelName }}
				</option>

			</select>

			<select v-if="this.baseMcTree" v-model="this.year">
				<option :value="null">Välj år</option>
				<option v-for="year in this.mc && this.mc.yearList.sort((a, b) => a.year < b.year)" :key="year.year"
					:value="year">{{
					year.year }}
				</option>

			</select>

		</div>
		<hr />

		<SelectMc :baseMcList="baseMcList" :baseMcTree="baseMcTree" :brand="this.brand" :mc="this.mc" :year="this.year" 
		@brandSelected="(brand) => this.brand = brand" 
		@mcSelected="(mc) => this.mc = mc"
		@yearSelected="(year) => this.year = year" />
	</div -->
	<SelectMc :baseMcList="baseMcList" :baseMcTree="baseMcTree" :brand="this.brand" :mc="this.mc" :year="this.year"
		@brandSelected="(brand) => this.brand = brand" @mcSelected="(mc) => this.mc = mc"
		@yearSelected="(year) => this.year = year" style="z-index:8;"/>
</template>
<script>

import SelectMc from '@/components/product/search/SelectMc.vue';
import { STORE_GETTER } from '../../../store/store';
//import { STORE_GETTER } from '@/store/store';

export default {
	name: "SelectMcWrapper",
	components: { SelectMc },
	mixins: [],
	props:{
		
	},
	data() {
		return {
			brand: null,
			mc: null,
			year: null,

		};
	},
	computed: {

		baseMcList() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.mcList) {
				return baseModel.mcList
			}

			return null;

		},
		baseMcTree() {

			const baseModel = this.$store.getters[STORE_GETTER.BASE_MODEL]

			if (baseModel && baseModel.mcTree) {
				return baseModel.mcTree
			}

			return null;

		},




	},
	watch: {

		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);

		// this.$store.dispatch({ type: PRODUCT_STORE_ACTION.TEST_GET_PRODUCT_LIST, data: {} });


	},
	created() {

	}
};
</script>

<style scoped></style>